// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.no-frame {\n  outline: none;\n}\ndiv.bgr-row {\n  display: flex;\n  flex-flow: row;\n  overflow: hidden;\n  outline: none;\n}\ndiv.bgr-cell {\n  display: flex;\n  overflow: hidden;\n}\ndiv.bgr-cell-b {\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n}\ndiv.brg-c-text {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n", ""]);
// Exports
module.exports = exports;
